import _ from 'lodash';

export function hasGlobalPermission(user, allowedPermissions) {
  let allowed = false;
  if (!user || !user.groups) {
    return false;
  }
  let groups = _.flatMap(user.groups, 'name');
  allowedPermissions.map((permission) => {
    if(groups.indexOf(permission) >= 0) {
      allowed = true;
    }
  });
  return allowed;
}

export function hasPermission(user, allowedPermissions, object, permissionType) {
  if(hasGlobalPermission(user, allowedPermissions)) {
    return true;
  }
  if (object && object.permissions && permissionType) {
    return object.permissions[permissionType] || false;
  }
  return false;
}



/** WEBPACK FOOTER **
 ** ./src/permission.js
 **/